import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emb-card" }
const _hoisted_2 = { class: "emb-card_body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref, toRefs } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { ModalType } from '../../constant';

export default /*@__PURE__*/_defineComponent({
  __name: 'ThankYouModal',
  props: {
    topPosition: {},
    printOptionSelected: { type: Boolean },
    showModal: { type: Boolean },
    mode: {}
  },
  emits: ['closeModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { topPosition, printOptionSelected, showModal, mode } = toRefs(props);
console.log(mode.value);

const emits = __emit;

const h3Message = ref('Thank you!');
const printOptionMessage = ref('Your printable map is being opened in a new window.');
const dreesMessage = ref('Your request will be reviewed first by our New Home Specialist. They will be in contact shortly to let you know the status of your request. We appreciate your patience.');

const handleClose = () => {
  emits('closeModal', ModalType.THANK_YOU);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    name: "thank-you",
    modelValue: _unref(showModal),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
    clickToClose: false,
    "content-style": { maxHeight: '100vh', overflowY: 'auto' },
    width: "100%",
    height: "100%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(mode) == 'customer' ? 'embthank' : 'embthank-sales'),
        style: _normalizeStyle({ top: `${_unref(topPosition)}px` })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(h3Message.value), 1),
            (_unref(printOptionSelected))
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(printOptionMessage.value), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(dreesMessage.value), 1)),
            _createElementVNode("button", {
              class: "btn",
              onClick: handleClose
            }, " Close ")
          ])
        ])
      ], 6)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})